<template>
  <div class="header__wrapper">
    <div class="nav__container">
      <div class="logo__container">
        <div class="logo">
          <a href="#"><img src="@/assets/header_logo.png" alt="logo" /></a>
        </div>
      </div>
      <div class="hamburger__menu">
        <img src="@/assets/hamburger_menu.png" alt="ham_menu" />
      </div>
      <div class="right__menu">
        <div class="menu__list">
          <a href="#" class="list__item">SCIENCE <span class="line">—</span></a>
          <a href="#" class="list__item"
            >APPROACH <span class="line">—</span></a
          >
          <a href="#" class="list__item"
            >APPLICATIONS <span class="line">—</span></a
          >
          <a href="#" class="list__item"
            >ABOUT US <span class="line">—</span></a
          >
          <a href="#" class="list__item">CAREERS <span class="line">—</span></a>
          <a href="#" class="list__item">BLOG <span class="line">—</span></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style>
/* Laptop responsive code */
@media only screen and (min-width: 601px) {
  .hamburger__menu {
    display: none;
  }
  a {
    text-decoration: none;
  }
  .line {
    position: absolute;
    display: none;
  }
  .nav__container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 3.5rem;
  }
  .menu__list {
    display: flex;
    flex-direction: column;
  }
  .list__item {
    text-align: end;
    color: white;
    line-height: 15pt;
    font-weight: bolder;
    font-family: "Barlow", sans-serif;
  }
  .list__item:hover + .line {
    display: block;
  }
  .logo > a > img {
    width: 57px;
    height: 39px;
  }
  .small__screen__menu {
    display: none;
  }
}

/* Mobile responsive code */
@media only screen and (max-width: 600px) {
  .hamburger__menu {
    display: block;
    cursor: pointer;
  }
  .hamburger__menu > img {
    width: 80px;
    height: 80px;
  }
  .right__menu {
    display: none;
  }
  .nav__container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 1.5rem;
  }
}
</style>
